import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPackage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"package, delivery"} maskId="square-filled-radius-0-stroke-1-IconPackage"><path fillRule="evenodd" clipRule="evenodd" d="M3 3V21H21V3H16V10H8V3H3ZM14.5 17V18H18V17H14.5Z" fill="currentColor"/><path d="M9 3H15V9H9V3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPackage;
